import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Protected = (props) => {
const naviget = useNavigate();
const { Component } = props;
       useEffect(() => {
        let login = localStorage.getItem("login2");
        if(!login){
            localStorage.setItem("loginStatus", "Please Login to enter in the system");
            naviget("/", {replace: true});
        }
       }, []);

    return(
        <Component />
    );
}

export default Protected


